import { GLOBAL_BOOLEANS } from "@/lib/args/args-constants";
export const BOOLEAN_FLAGS = new Set<string>([
  ...GLOBAL_BOOLEANS,
  "follow",
  "all",
  "version",
]);
